import en from './translations/en';
import de from './translations/de';

const messages = {
  de,
  en
};

export default messages;
